export default __webpack_public_path__ + "static/media/marker-active-icon.b71bde9e.svg";